/**
 * Composer de una línea para los chats simples (supportIA, TA Metrics,
 * asistente del Brain): input + Enter envía (Shift+Enter no) + botón.
 * Auditoría 18/09/2026: la misma fila estaba escrita 3 veces (y 2 más con
 * Textarea + voz en D-Talk y el Mapa de Talento, que tienen su propia lógica
 * de dictado y quedan afuera a propósito).
 */
import type { ReactNode } from 'react';
import { ArrowRight } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

export function ChatComposer({ value, onChange, onSend, placeholder, disabled, pending, maxLength, icon, className, inputClassName, buttonClassName }: {
  value: string;
  onChange: (v: string) => void;
  onSend: () => void;
  placeholder?: string;
  /** Bloquea el input (p. ej. mientras responde). */
  disabled?: boolean;
  /** Solo deshabilita el botón (el input sigue editable). */
  pending?: boolean;
  maxLength?: number;
  icon?: ReactNode;
  className?: string;
  inputClassName?: string;
  buttonClassName?: string;
}) {
  const canSend = !!value.trim() && !pending && !disabled;
  return (
    <div className={cn('flex gap-2', className)}>
      <Input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); if (canSend) onSend(); } }}
        placeholder={placeholder}
        maxLength={maxLength}
        disabled={disabled}
        className={cn('flex-1', inputClassName)}
      />
      <Button size="icon" onClick={onSend} disabled={!canSend} className={buttonClassName} aria-label={placeholder}>
        {icon ?? <ArrowRight size={16} />}
      </Button>
    </div>
  );
}
